import React from 'react';
import {connect} from 'react-redux';
import { List, Button, Tooltip, message} from 'antd';
import { ScheduleOutlined } from '@ant-design/icons'
import { VocabsRepository, VocabsIndividual } from '../../redux';
import { LoadingComponent } from '../../utils/ui';
import Description from '../widgets/Description';
import i18n from "i18next";


const isIndividualHighlighted = (individual, highlight) => {
  return Array.isArray(highlight) && highlight.includes(individual?.IRI?.value);
};

//  см. https://ant.design/components/list/
class IndividualsRepository extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.state = {
      loading: false, 			//Флаг загрузки
    }
    this.onSelectedInList = this.onSelectedInList.bind(this);
  }
  
  componentDidMount() {
    const {schemes, state} = this.props;
    if (state=="empty")
      this.onLoadMore();
  }

  //вызывается только в случае передачи компоненту новых свойств
	//единственный метод ЖЦ компоненты, в котором может быть вызван метод setState;
	componentWillReceiveProps(nextProps){
    const {state, conditions} = nextProps;
    if (state=="empty")
      this.onLoadMore(true, conditions);
  }
    
  onSelectedInList (IRI, item) {
    const {onSelected, router} = this.props;
    if (onSelected) 
      onSelected(IRI, VocabsIndividual, router.navigate, item);
  }

  /** Метод начального считывания, когда offset=0. Разница в получении количества записей */
  loadFirst = (filter=null) => {
    const {conditions, rdfTypes, lang} = this.props;
    this.props.dispatch(VocabsRepository.loadVocabs((filter)?filter:conditions, rdfTypes, lang))
      .then ((response) =>{
        const {head, results} = response[0];
        const {distinct, ordered, bindings} = results;
        this.setState({loading: false,}, () => { window.dispatchEvent(new Event('resize')); });
      })
      .catch(e => { 
        message.error(`Ошибка получения данных. ${e}`);
        this.setState({loading: false})
      });
  }
  /** Метод для досчитывания данных */
  onLoadMore = (reload=false, filter=null) => {
    console.log("onLoadMore", reload, filter, this.state, this.props);
    if (this.state.loading == true) return;
    this.setState({ loading: true });
    const {items, conditions, rdfTypes, lang} = this.props;
    const offset = (!reload && items && Array.isArray(items))?items.length:0;
    if (offset==0){
      this.loadFirst(filter);
      return;
    }
    this.props.dispatch(VocabsRepository.loadNextVocabs(offset, (filter)?filter:conditions, rdfTypes, lang))
      .then ((response) =>{
        const {head, results} = response;
        const {distinct, ordered, bindings} = results;
        this.setState({
          loading: false,
        }, () => {
          // Resetting window's offsetTop so as to display react-virtualized demo underfloor.
          // In real scene, you can using public method of react-virtualized:
          // https://stackoverflow.com/questions/46700726/how-to-use-public-method-updateposition-of-react-virtualized
          window.dispatchEvent(new Event('resize'));
        });
      })
      .catch(e => { 
        message.error(`Ошибка получения данных. ${e}`);
        this.setState({loading: false})
      });
    };
  
    render() {
      const { loading  } = this.state;
      const { items, count, highlight } = this.props;
      const loadMore = loading ? (
        <div style={{textAlign: 'center', marginTop: 12, height: 32, lineHeight: '32px'}}><LoadingComponent /></div>
      ) : (
        ((items.length != count) && (count>0))?
        <div style={{textAlign: 'center', marginTop: 12, height: 32, lineHeight: '32px', display1: 'none'}}>
          <Tooltip placement="top" title= {i18n.t('components.adms.repository_tooltip', {count: count, length:count-items.length})}>
            <Button onClick={() => this.onLoadMore()}>{i18n.t('components.adms.repository_load_next')}</Button>
          </Tooltip>
        </div>
        : null
      );
      console.log(this);
      return (
        <List
          className="demo-loadmore-list adms_category_div csi_spoiler active"
          loading={loading}
          itemLayout="horizontal"
          loadMore={loadMore}
          dataSource={items}
          renderItem={item => {
            const isHighlighted = isIndividualHighlighted(item, highlight);
            return (
            <List.Item actions={[]} 
              style={{
                padding: 0,
                backgroundColor: isHighlighted ? "#fff3cd" : undefined,
                borderRadius: isHighlighted ? 4 : undefined
              }} 
              onClick={()=> this.onSelectedInList(item.IRI.value, item) }>
              <div className="adms_asset_meta" style={{width: "100%"}}>
                <h3>{(item.dsn)?item.dsn.value:""} 
                    <small>{(item.dsv)?"("+item.dsv.value+")":""}</small> 
                    {item.catalog && item.catalog.state == 'loaded' && (<ScheduleOutlined style={{float: "right"}}/>)}
                </h3> 
                <p><Description IRI={item.IRI.value} description={item.description} actions={VocabsRepository}/></p>
              </div>
            </List.Item>
          )}}
        />
      );
    }
  }
  
  function mapStateToProps(state, props) {
    return {
        ...state.vocabs
    };
  }
  
  export default connect(mapStateToProps)(IndividualsRepository);